import { render } from "./MountingShopRecordView.vue?vue&type=template&id=8508665e&scoped=true"
import script from "./MountingShopRecordView.vue?vue&type=script&lang=js"
export * from "./MountingShopRecordView.vue?vue&type=script&lang=js"

import "./MountingShopRecordView.vue?vue&type=style&index=0&id=8508665e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8508665e"]])

export default __exports__